"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCollectionModel = exports.IkeObjectCollection = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectCollection = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectCollection, _super);
    function IkeObjectCollection() {
        var _this = _super.call(this) || this;
        _this.className = 'Collection';
        _this.actionName = 'collection';
        _this.cacheKeys['uuid'] = true;
        _this.cacheKeys['revision'] = true;
        return _this;
    }
    IkeObjectCollection.prototype.updateCache = function (key, result, rest) {
        _super.prototype.updateCache.call(this, key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
    };
    return IkeObjectCollection;
}(base_1.IkeRestObject));
exports.IkeObjectCollection = IkeObjectCollection;
exports.IkeObjectCollectionModel = {
    className: 'CollectionModel',
    actionName: 'collection.model',
    canCache: function (key) {
        return key === 'revision';
    }
};
//# sourceMappingURL=collection.object.js.map